import { render, staticRenderFns } from "./smsOrg.vue?vue&type=template&id=a9f1b176&"
import script from "./smsOrg.vue?vue&type=script&lang=js&"
export * from "./smsOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports